import React from 'react';

import Modal from './Modal';
import Button from '../FormElements/Button';

import './ErrorModal.css';

const ErrorModal = props => {
  return (
    <Modal
      onCancel={props.onClear}
      header='An Error Occurred!'
      show={!!props.error}
      footer={
        <Button className='btn-error' onClick={props.onClear}>
          Ok
        </Button>
      }
    >
      <p>{props.error}</p>
    </Modal>
  );
};

export default ErrorModal;
